module.exports = __webpack_public_path__ + "User_Guide_NBDB_En_Oct_2026.pdf";